module.exports = __webpack_public_path__ + "static/proteam-3242a9c971770b3f4e4c2fea0c9db915.png";